<header *ngIf="!this.isLandingPageHeader" class="site-header">
  <nav class="navbar navbar-expand-lg navbar-dark" id="paloNavbar" role="navigation">
    <div [ngClass]="isCloudAcademy ? 'container' : 'container-fluid'">
      <ng-container *ngIf="!isCloudAcademy">
        <a class="navbar-brand" routerLink="/">
          <img alt="FlexBenefits Logo" class="site-header__logo" src="/assets/img/flexbenefits-logo-white.svg">
        </a>
      </ng-container>
      <ng-container *ngIf="isCloudAcademy">
        <a class="navbar-brand" routerLink="/">
          <img alt="Cloud Academy Logo" src="/assets/img/cloud-header-logo.png">
        </a>
      </ng-container>

      <div (click)="isCollapsed = !isCollapsed; menuStateCheck(isCollapsed)"
           *ngIf="!isCloudAcademy"
           [attr.aria-expanded]="!isCollapsed"
           [ngClass]="{'open' : !isCollapsed}"
           aria-controls="navbarSupportedContent"
           aria-label="Toggle navigation"
           class="navbar-toggler"
           id="mobile-nav-icon">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <ul *ngIf="isCloudAcademy" class="navbar-nav flex-lg-fill justify-content-end">
        <ng-container *ngIf="this.client.currentSetLanguage === 'en_GB'">
          <li class="nav-item cloudacademy" id="cloud-apply">
            <a class="cloudacademy__btn" href="https://gcly.io/o3VY" target="_blank">Apply now</a>
          </li>
        </ng-container>
        <ng-container *ngIf="this.client.currentSetLanguage === 'fr'">
          <li class="nav-item cloudacademy" id="cloud-apply">
            <a class="cloudacademy__btn" href="https://gcly.io/palofr" target="_blank">Postulez maintenant</a>
          </li>
        </ng-container>
        <ng-container *ngIf="this.client.currentSetLanguage === 'de'">
          <li class="nav-item cloudacademy" id="cloud-apply">
            <a class="cloudacademy__btn" href="https://gcly.io/palode" target="_blank">Jetzt bewerben</a>
          </li>
        </ng-container>
        <core-block-client-language [block]="$any({data: {}, languageData:{}, content:[]})"></core-block-client-language>
      </ul>

      <div #collapse="bs-collapse" [collapse]="isCollapsed" class="collapse navbar-collapse ms-auto" id="collapseBasic">
        <ul class="navbar-nav">
          <ng-container *ngIf="!isCloudAcademy">
            <ng-container *ngIf="pages$ | async as _pages">
              <ng-container *ngFor="let page of _pages trackBy: trackByFn">
              <ng-container *ngIf="page.children.length === 0 || page.meta.hideNavDropdown">
                <li *ngIf="page.meta.showInMenu == 'true' || page.meta.showInMenu == '\'true\'' || page.meta.showInMenu == true"
                    class="nav-item">
                  <ng-container *ngIf="page.meta.redirect">
                    <a (click)="navigateToPage(page.meta.redirect)" aria-current="page"
                       class="nav-link"
                       href="javascript:void(0)"
                       id="{{page.url}}">
                      {{page.meta.friendlyPageName || page.name}}
                    </a>
                  </ng-container>
                  <ng-container *ngIf="!page.meta.redirect">
                    <a (click)="navigateToPage(page.url)" aria-current="page"
                       class="nav-link"
                       href="javascript:void(0)"
                       id="{{page.url}}">
                      {{page.meta.friendlyPageName || page.name}}
                    </a>
                  </ng-container>
                </li>
              </ng-container>
              <ng-container *ngIf="page.children.length > 0">
                <li *ngIf="(page.meta.showInMenu == 'true' || page.meta.showInMenu == '\'true\'' || page.meta.showInMenu == true) && !page.meta.hideNavDropdown" class="nav-item dropdown"
                    dropdown>
                  <a [ngClass]="{'active' : isBenefitSubpage}" aria-expanded="false" class="nav-link dropdown-toggle"
                     dropdownToggle
                     href="javascript:void(0)" id="navbarDropdown" role="button">
                    {{page.name}}
                  </a>
                  <ng-container *ngIf="content$ | async as content">
                    <div *dropdownMenu aria-labelledby="navbarDropdown" class="dropdown-menu" id="dropdown">
                      <div class="dropdown-wrapper activeMenuTab-{{activeMenuTab.value}}">
                        <mat-tab-group (selectedIndexChange)="activeMenuTab.setValue($event)" class="nav nav-menu-tabs mx-auto"
                                       mat-align-tabs="center">
                          <mat-tab *ngFor="let item of content; trackBy: trackByFn">
                            <ng-template mat-tab-label>
                              <span (mouseenter)="mouseEnter(item, $event)" (mouseleave)="mouseLeave()"
                                    [innerHTML]="item.name"></span>
                            </ng-template>
                            <div class="nav-menu-wrapper nav-menu-wrapper--{{activeMenuTab.value}}">
                              <div *ngFor="let page of item.pageCategories | orderBy:['displayOrder']"
                                   class="nav-menu-item">
                                <ng-container *ngIf="page.meta.redirect">
                                  <a (click)="this.navigateToPage(page.meta.redirect)"
                                     [attr.aria-label]="'Learn more about ' + page.name"
                                     href="javascript:void(0)">
                                  <span><img *ngIf="page.meta.pageIcon" [alt]="page.name"
                                             [src]="page.meta.pageIcon | cdn"></span>
                                    <span>{{page.name}}</span>
                                  </a>
                                </ng-container>
                                <ng-container *ngIf="!page.meta.redirect">
                                  <a (click)="this.navigateToPage(page.url)"
                                     [attr.aria-label]="'Learn more about ' + page.name"
                                     href="javascript:void(0)">
                                  <span><img *ngIf="page.meta.pageIcon" [alt]="page.name"
                                             [src]="page.meta.pageIcon | cdn"></span>
                                    <span>{{page.name}}</span>
                                  </a>
                                </ng-container>
                              </div>
                            </div>
                          </mat-tab>
                        </mat-tab-group>
                        <div class="nav-menu-helper" id="nav-menu-helper__foundational">Basic health, finance,
                          retirement and time off benefits.
                        </div>
                        <div class="nav-menu-helper" id="nav-menu-helper__supplemental">Optional top-up health and
                          finance benefits.
                        </div>
                        <div class="nav-menu-helper" id="nav-menu-helper__flexible">Support and lifestyle benefits
                          designed around you.
                        </div>
                        <a (click)="navigateToPage('/my-benefits')" class="btn btn-primary" href="javascript:void(0)">Explore
                          all benefits</a>
                      </div>

                      <div class="dropdown-wrapper-mobile">
                        <a (click)="toggleChildNav(item)"
                           *ngFor="let item of content; trackBy: trackByFn"
                           class="mobile-nav__link mobile-nav__link--{{item.name | lowercase | nonAlphaNumeric:50 }}"
                           href="javascript:void(0)">
                          <span>{{item.name}}</span>
                        </a>
                      </div>
                    </div>
                  </ng-container>
                </li>
              </ng-container>
            </ng-container>
          </ng-container>
          </ng-container>
        </ul>

        <ng-container *ngIf="!isCloudAcademy">
          <ng-container *ngIf="content$ | async as categoryName">
          <ng-container *ngFor="let item of categoryName; trackBy: trackByFn">
            <div [ngClass]="{'benefits-submenu--open':childNav}" class="benefits-submenu"
                 id="benefits-submenu-{{item.name | lowercase | nonAlphaNumeric:50}}">
              <header>
                <span class="benefits-submenu__title">{{item.name}}</span>
                <a (click)="closeChildNav()" class="btn" href="javascript:void(0);">Back</a>
              </header>

              <div class="benefits-submenu__wrapper">
                <div *ngFor="let page of item.pageCategories | orderBy:['displayOrder']" class="nav-menu-item">
                  <ng-container *ngIf="page.meta.redirect">
                    <a (click)="this.navigateToPage(page.meta.redirect)"
                       [attr.aria-label]="'Learn more about ' + page.name"
                       href="javascript:void(0)">
                      <img *ngIf="page.meta.pageIcon" [alt]="page.name" [src]="page.meta.pageIcon">
                      <span>{{page.name}}</span>
                    </a>
                  </ng-container>
                  <ng-container *ngIf="!page.meta.redirect">
                    <a (click)="this.navigateToPage(page.url)"
                       [attr.aria-label]="'Learn more about ' + page.name"
                       href="javascript:void(0)">
                      <img *ngIf="page.meta.pageIcon" [alt]="page.name" [src]="page.meta.pageIcon">
                      <span>{{page.name}}</span>
                    </a>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
          </ng-container>
        </ng-container>
        <a class="flexcredit-banner" href="#">
          <img alt="" src="/assets/img/flexcredit-banner.png">
        </a>
      </div>
    </div>
  </nav>
</header>
